import React, { useState } from "react";
import { Button, DatePicker, Form, Input } from 'antd';
import { SearchOutlined } from "@ant-design/icons";
import { DrawerStandart, Localize } from "components/service";
import Icons from 'components/icons';
import { gqlBuilderWhere, helperFunc } from "utils";

const { Search } = Input;
const { RangePicker } = DatePicker;


const textFilterFields = [
    {
        name: 'MODEL',
        label: 'FORMS.Input_Label_Model',
    },
    {
        name: 'LANG_SOURCE',
        label: 'FORMS.Input_Label_SourceLanguage',
    },
    {
        name: 'LANG_TARGET',
        label: 'FORMS.Input_Label_TargetLanguage',
    },
];

const TranslationAiTableFilter = ({
    setSearchText,
    setFilters,
    dateColumn,
    searchPlaceholder,
    showRequestFilters = false,
}) => {

    const [ form ] = Form.useForm();
    const [ filterList, setFilterList ] = useState({});
    const [ count, setCount ] = useState({});

    const filterCount = helperFunc.countFilterList(count);

    const setFilter = (name, filter) => {
        setFilterList((filterList) => ({
            ...filterList,
            [ name ]: filter
        }));
    };

    const onTextFilterChange = (event) => {
        const { name, value } = event.target;

        setFilter(
            name,
            value ?
                {
                    column: name,
                    operator: "LIKE",
                    value: `%${ value }%`
                } :
                {}
        );
    };

    const onDateChange = (_, dateStrings) => {
        setFilter(
            dateColumn,
            dateStrings[ 0 ] !== '' ?
                {
                    column: dateColumn,
                    operator: "BETWEEN",
                    value: dateStrings
                } :
                {}
        );
    };

    const applyFilters = (action = () => { }) => {
        setFilters(gqlBuilderWhere(filterList));
        setCount(filterList);
        action();
    };

    const resetFilters = () => {
        const formFields = [ dateColumn, ...textFilterFields.map(({ name }) => name) ];

        form.resetFields(formFields);
        setFilterList({});
        setCount({});
        setFilters(gqlBuilderWhere({}));
    };

    return (
        <>
            <Search
                className="filter-search"
                prefix={ <SearchOutlined /> }
                placeholder={ Localize({ children: searchPlaceholder }).props.children }
                onChange={ (event) => setSearchText(event.target.value) }
            />

            <Form
                key="filters-form"
                className="clear-css-prop table-filter-form"
                layout="vertical"
                form={ form }>

                <DrawerStandart
                    width="287"
                    extraClass={ 'modal-form filters' }
                    modalButton={
                        <Button>
                            <Icons.Filter />
                            <span><Localize>FORMS.Button_Text_ApplyFilters</Localize></span>
                            { filterCount && <span className="filter-count">{ filterCount }</span> }
                        </Button>
                    }
                >
                    <TranslationAiFilterContent
                        dateColumn={ dateColumn }
                        showRequestFilters={ showRequestFilters }
                        onDateChange={ onDateChange }
                        onTextFilterChange={ onTextFilterChange }
                        applyFilters={ applyFilters }
                        resetFilters={ resetFilters }
                    />
                </DrawerStandart>
            </Form>
        </>
    );
};

const TranslationAiFilterContent = ({
    action,
    dateColumn,
    showRequestFilters,
    onDateChange,
    onTextFilterChange,
    applyFilters,
    resetFilters,
}) => (
    <div className="ant-form ant-form-vertical filters-form">
        <strong className="modal-title">
            <Localize>FORMS.Title_Text_Filters</Localize>
        </strong>

        <Form.Item
            name={ dateColumn }
            label={ <Localize>FORMS.Input_Label_Time</Localize> }
        >
            <RangePicker
                separator="&ndash;"
                placeholder={ [
                    Localize({ children: "FORMS.Input_Placeholder_StartDate" }).props.children,
                    Localize({ children: "FORMS.Input_Placeholder_EndDate" }).props.children
                ] }
                onChange={ onDateChange } />
        </Form.Item>

        { showRequestFilters &&
            textFilterFields.map(({ name, label }) => (
                <Form.Item
                    key={ name }
                    name={ name }
                    label={ <Localize>{ label }</Localize> }>
                    <Input name={ name } onChange={ onTextFilterChange } />
                </Form.Item>
            ))
        }

        <div className="form-btn-holder">
            <Button
                type="primary"
                htmlType="submit"
                onClick={ () => applyFilters(action) }
            >
                <Localize>FORMS.Button_Text_ApplyFilters</Localize>
            </Button>
            <Button
                className="ant-btn-secondary bg-light-gray btn-right"
                htmlType="button"
                onClick={ resetFilters }
            >
                <Localize>FORMS.Button_Text_ResetFilters</Localize>
            </Button>
        </div>
    </div>
);

export default TranslationAiTableFilter;
